module.exports = __webpack_public_path__ + "media/images/team_wecasa@3x-bbddcfeb05745a6bc997df9b17dc1c9b.jpg";